// extracted by mini-css-extract-plugin
export default {"register":"register_register__h3DuI","form":"register_form__Nwdcb","hideshow":"register_hideshow__RWo0M","button":"register_button__nfnZh","icon":"register_icon__8EQUN"};